import React, { useState } from "react";
import toast from "react-hot-toast";
import { generarCheckout, generarPagoTemp } from "../api";

const SubscriptionBottomSheet = ({ onClose, onContinue, precios, id_perfil  }) => {
  const [plan, setPlan] = useState("anual");
  const [step, setStep] = useState(1);
  const [loadingPago, setLoadingPago] = useState(false);
  const inscripcion = parseFloat(precios?.inscripcion || 0);
  const mensualidad = parseFloat(precios?.mensualidad || 0);
  const descuento = parseFloat(precios?.descuento || 0);
  const anual = mensualidad * 12;
  const mensualidadAnual = parseFloat((anual - descuento) / 12).toFixed(2);
  const montoMembresia = plan === "anual" ? anual - descuento : mensualidad;
  const total = inscripcion + montoMembresia;

  const handleContinue = () => {
    if (step === 1) {
      setStep(2);
    } else {
      onContinue(plan);
    }
  };

  const handlePay = async () => {
    if (!id_perfil || !plan) {
      toast.dismiss();
      toast.error("Faltan datos obligatorios");
      return;
    }
  
    setLoadingPago(true); // Mostrar spinner

    try {
      const temp = await generarPagoTemp(plan, id_perfil);
  
      if (!temp.success || !temp.code) {
        setLoadingPago(false);
        toast.dismiss();
        toast.error("No se pudo preparar el pago");
        return;
      }

      const code = temp.code;
      const checkout = await generarCheckout(plan, id_perfil, code);
  
      if (checkout.success && checkout.checkout_url) {
        window.location.href = checkout.checkout_url;
      } else {
        setLoadingPago(false);
        toast.dismiss();
        toast.error(checkout.message || "No se pudo generar el pago.");
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Ocurrió un error inesperado");
      setLoadingPago(false);
    }
  };   

  return (
    <>
      <div className="subscription-overlay" onClick={onClose}></div>
      <div className="subscription-sheet">
        <div className="subscription-header">
          <button className="subscription-close" onClick={onClose}>×</button>
        </div>

        <div className="subscription-content">
          {step === 1 ? (
            <>
              <img src="/assets/images/membership.svg" style={{ width: 80, marginBottom: 20, marginTop: 5 }} />
              <h3>Publica. Conecta. Crece.</h3>
              <p>
                Da a conocer tu negocio, llega a más clientes y desbloquea funciones premium para impulsar tu presencia.
              </p>
              <div className="subscription-options">
                <label className={`subscription-option ${plan === "anual" ? "selected" : ""}`}>
                  <input type="radio" name="plan" checked={plan === "anual"} onChange={() => setPlan("anual")} />
                  <div style={{ lineHeight: 1 }}>
                    <div><strong>Anual Q{anual - descuento}</strong> (Q{mensualidadAnual} al mes)</div>
                    <span className="subscription-save">Ahorras Q{descuento}</span>
                  </div>
                </label>
                <label className={`subscription-option ${plan === "mensual" ? "selected" : ""}`}>
                  <input type="radio" name="plan" checked={plan === "mensual"} onChange={() => setPlan("mensual")} />
                  <div><strong>Mensual Q{mensualidad}</strong></div>
                </label>
              </div>
              <div style={{ marginTop: 20, textAlign: "left", fontSize: 13, lineHeight: 1.3 }}>
                <b>IMPORTANTE:</b> Pagarás una tarifa única de inscripción a comerciante de <b>Q{inscripcion}</b>, adicional a tu membresía mensual de <b>Q{mensualidad}</b>, la cual te incluye la publicación de sucursales ilimitadas.
              </div>
            </>
          ) : (
            <>
              <h3 style={{ fontWeight: "bold", fontSize: 30, marginTop:15, paddingBottom:5 }}>Q{total.toLocaleString("es-GT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h3>

              <div style={{ marginTop: 20, textAlign: "left", fontSize: 14 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 15, marginBottom: 15 }}>
                  <img src="/assets/images/membership.svg" style={{ width: 40, height: 50, borderRadius: 12, background: "#fff" }} />
                  <div>
                    <h4 style={{ margin: 0, fontSize:15, fontWeight:800 }}>Suscripción de comerciante</h4>
                    <small>Acceso completo a herramientas y publicación ilimitada</small>
                  </div>
                </div>

                <p style={{ fontWeight: "bold", marginBottom: 20,paddingTop:5, textAlign: "center" }}>Detalle del pago</p>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                  <span>Inscripción única:</span>
                  <span>Q{inscripcion.toFixed(2)}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                  <span>{plan === "anual" ? "Membresía anual:" : "Membresía mensual:"}</span>
                  <span>Q{montoMembresia.toFixed(2)}</span>
                </div>
                <div style={{ borderTop: "1px solid #ccc", paddingTop: 10, fontWeight: "bold", display: "flex", justifyContent: "space-between" }}>
                  <span>Total a pagar:</span>
                  <span>Q{total.toLocaleString("es-GT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>
              </div>
            </>
            )}
            <button className="subscription-button" onClick={step === 1 ? handleContinue : handlePay}>
                {step === 1 ? "Continuar" : "Pagar ahora"}
            </button>
            {step === 2 && (
                <div style={{ textAlign: "left", marginTop: 10, fontSize: 12, paddingBottom: 15 }}>
                    <b>NOTA:</b> Saldrás hacia Recurrente <img src="/assets/images/recurrente.svg" width={17} />, para finalizar la transacción.
                </div>
            )}
          <p className="subscription-footer">
            Al continuar, aceptas nuestros <a href="#">Términos de Uso</a> y <a href="#">Política de Privacidad</a>.
          </p>
        </div>
        {loadingPago && (
          <div style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <div style={{
              width: "60px",
              height: "60px",
              border: "6px solid #f3f3f3",
              borderTop: "6px solid #3498db",
              borderRadius: "50%",
              animation: "spin 1s linear infinite"
            }}></div>
            <style>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
          </div>
        )}

      </div>
    </>
  );
};

export default SubscriptionBottomSheet;